import { a as querySelectorDeep } from './query-selector-shadow-dom-dc946919.js';
import { B as BxfOverlayDropdownController } from './overlay-dropdown-controller-d9d1cfbe.js';

var BxfDatePickerDateFormatEnum;
(function (BxfDatePickerDateFormatEnum) {
    BxfDatePickerDateFormatEnum["DD_MM_YYYY"] = "DD MM YYYY";
    BxfDatePickerDateFormatEnum["MM_DD_YYYY"] = "MM DD YYYY";
    BxfDatePickerDateFormatEnum["YYYY_MM_DD"] = "YYYY MM DD";
    BxfDatePickerDateFormatEnum["DD_MMM_YYYY"] = "DD MMM YYYY";
    BxfDatePickerDateFormatEnum["MMM_DD_YYYY"] = "MMM DD YYYY";
    BxfDatePickerDateFormatEnum["DD_MMMM_YYYY"] = "DD MMMM YYYY";
    BxfDatePickerDateFormatEnum["MMMM_DD_YYYY"] = "MMMM DD YYYY";
})(BxfDatePickerDateFormatEnum || (BxfDatePickerDateFormatEnum = {}));

class BxfCalendarConstants {
    static STRING = {
        JANUARY: 'January',
        FEBRUARY: 'February',
        MARCH: 'March',
        APRIL: 'April',
        MAY: 'May',
        JUNE: 'June',
        JULY: 'July',
        AUGUST: 'August',
        SEPTEMBER: 'September',
        OCTOBER: 'October',
        NOVEMBER: 'November',
        DECEMBER: 'December',
        SUNDAY: 'S',
        MONDAY: 'M',
        TUESDAY: 'T',
        WEDNESDAY: 'W',
        THURSDAY: 'T',
        FRIDAY: 'F',
        SATURDAY: 'S',
        HOLIDAYS_LABEL: 'Holidays',
        SUNDAY_FULL: 'Sunday',
        MONDAY_FULL: 'Monday',
        TUESDAY_FULL: 'Tuesday',
        WEDNESDAY_FULL: 'Wednesday',
        THURSDAY_FULL: 'Thursday',
        FRIDAY_FULL: 'Friday',
        SATURDAY_FULL: 'Saturday',
        FULL_MONTH: 'MMMM',
        MONTH_NUMBER: 'M',
        DAY_NUMBER: 'D',
        FULL_YEAR: 'YYYY',
        FULL_DATE: 'DD/MMMM/YYYY',
        DATA_DATE: 'data-date',
        DATA_MONTH: 'data-month',
        DATA_YEAR: 'data-year',
        MONTH: 'month',
        MONTHS: 'months',
        MONTH_LABEL: 'Select Month',
        PREV_MONTH: 'Previous Month',
        NEXT_MONTH: 'Next Month',
        YEAR_LABEL: 'Select Year',
        CALENDAR_LABEL: 'Calendar',
        SETTINGS_LABEL: 'Calendar Settings',
        RADIO_LABEL: 'Date Format',
        HIDDEN: 'hidden',
        INHERIT: 'inherit',
        BXF_DATEPICKER: 'bxf-date-picker',
        CALENDAR: 'calendar',
        DEFAULT_US: 'Default, US',
        CONTAINER: 'bxf-calendar__container',
        STANDALONE_CONTAINER: 'bxf-calendar__container--standalone',
        SETTINGS_CONTAINER: 'bxf-calendar-settings__container',
        HEADER: 'bxf-calendar__header',
        HEADER_FACET_BTN: 'bxf-calendar__header--facet-btn',
        TRANSPARENT_CELL: 'bxf-calendar__table-cell--transparent',
        STATIC_HEADER: 'bxf-calendar__header--static',
        HEADER_PREV_MONTH: 'bxf-calendar__header--previous',
        HEADER_NEXT_MONTH: 'bxf-calendar__header--next',
        MONTHS_BOX: 'bxf-calendar__header-months',
        YEARS_BOX: 'bxf-calendar__header-years',
        BUTTONS_BOX: 'bxf-calendar__header-buttons',
        HOLIDAY_FOOTER_BADGE: 'bxf-calendar__footer__badge--holiday',
        FOOTER_BADGE_LABEL: 'bxf-calendar__badge__label',
        MARKER_A_FOOTER_BADGE: 'bxf-calendar__footer__badge--markerA',
        MARKER_B_FOOTER_BADGE: 'bxf-calendar__footer__badge--markerB',
        BUTTON_XSMALL: 'bxf-calendar__header-buttons__xsmall',
        CALENDARS_BOX: 'bxf-calendar-settings__calendars',
        TABLE: 'bxf-calendar__table',
        TABLE_FACET_BTN: 'bxf-calendar__table--facet-btn',
        TABLE_ROW: 'bxf-calendar__table-row',
        TABLE_HEADER: 'bxf-calendar__table-header',
        TODAY_MENU_CONTAINER: 'bxf-calendar__today_menu',
        TABLE_CELL: 'bxf-calendar__table-cell',
        TABLE_CELL_RANGE_BOUND: 'bxf-calendar__table-cell--range-bound',
        TABLE_CELL_ACTIVE_MONTH: 'bxf-calendar__table-cell--active_month',
        TABLE_CELL_INACTIVE_MONTH: 'bxf-calendar__table-cell--inactive_month',
        CELL_IN_RANGE: 'bxf-calendar__table-cell__in_range',
        CELL_RANGE_SELECTED: 'bxf-calendar__table-cell__range_selected',
        CELL_RANGE: 'bxf-calendar__table-cell_range',
        CELL_NOT_SELECTABLE: 'bxf-calendar__table-cell--not_selectable',
        STATIC_CALENDAR: 'bxf-calendar__table-cell--static',
        TABLE_CELL_TODAY: 'bxf-calendar__table-cell--today',
        TABLE_CELL_SELECTED: 'bxf-calendar__table-cell--selected',
        TABLE_CELL_DISABLED: 'bxf-calendar__table-cell--disabled',
        BADGE: 'bxf-calendar__badge',
        BADGE_POSITIONING: 'bxf-calendar__badge__positioning',
        HOLIDAY_BADGE: 'bxf-calendar__badge--holiday',
        MARKER_A_BADGE: 'bxf-calendar__badge--markerA',
        MARKER_B_BADGE: 'bxf-calendar__badge--markerB',
        HOLIDAY_POPOVER: 'bxf-calendar__popover__badge--holiday',
        MARKER_A_POPOVER: 'bxf-calendar__popover__badge--markerA',
        MARKER_B_POPOVER: 'bxf-calendar__popover__badge--markerB',
        FOOTER: 'bxf-calendar__footer',
        INVALID_RANGE: 'bxf-calendar__table-cell--invalid-range',
        CALENDAR_GROUP_CONTAINER: 'bxf-calendar-group__container',
        CALENDAR_CONTAINER_SPACE: 'bxf-calendar-group__container--space',
        CALENDAR_GROUP: 'bxf-calendar-group',
        FOOTER_SELECTED: 'bxf-calendar__footer--selected',
        OVERLAY_PADDING: 'bxf-calendar__overlay--padding',
        KEY_CONTAINER: 'bxf-calendar__key__container',
        KEY_ITEM: 'bxf-calendar__key__item__container',
        FOOTER_RIGHT: 'bxf-calendar__footer--right',
        SECONDARY_TEXT_COLOR: 'var(--secondary-text__color)',
        SELECT_OVERFLOW_HEIGHT: '200px',
        SHORTCUTS_CONTAINER: 'bxf-calendar__footer--shortcuts-container',
        CALENDAR_NOTE_CONTAINER: 'bxf-calendar__calendar-note--container',
        CALENDAR_NOTE: 'bxf-calendar__calendar-note',
        CALENDAR_ROW: 'bxf-calendar__calendar--row',
        FOOTER_LABEL_TEXT: 'bxf-calendar__footer__label--text',
        CELL_POPOVER_CONTAINER: 'bxf-calendar-popover__container',
        FOOTER_TODAY_LABEL: 'Today',
        FOOTER_DONE_LABEL: 'Done',
        RESET: 'Reset',
        SMALL: 'small',
        SETTINGS: 'Settings',
        DIALOG: 'dialog',
        SEPARATOR_LABEL: 'Separator',
        FOOTER_SETTINGS: 'bxf-calendar__footer--settings',
        FOOTER_SELECT: 'bxf-calendar__footer--select',
        FOOTER_SETTINGS_ICON: 'bxf-calendar__footer--settings-icon',
        FOOTER_TODAY: 'bxf-calendar__footer--today',
        FOOTER_RESET: 'bxf-calendar__footer--reset',
        LABEL: 'bxf-calendar__footer--label',
        SHORTCUT_SEPARATOR: 'bxf-calendar__shortcut__separator',
        SEPARATOR: '|',
        SUNDAY_SELECTED: 'bxf-calendar__footer--sunday-selected',
        SUNDAY_RANGE: 'bxf-calendar__footer--sunday',
        SPLIT_BUTTON_MENU: 'Split Button Inline Menu',
        DEFAULT_MAX_YEAR: 9999,
        DEFAULT_MIN_YEAR: 1,
    };
    static MONTHS = [
        BxfCalendarConstants.STRING.JANUARY,
        BxfCalendarConstants.STRING.FEBRUARY,
        BxfCalendarConstants.STRING.MARCH,
        BxfCalendarConstants.STRING.APRIL,
        BxfCalendarConstants.STRING.MAY,
        BxfCalendarConstants.STRING.JUNE,
        BxfCalendarConstants.STRING.JULY,
        BxfCalendarConstants.STRING.AUGUST,
        BxfCalendarConstants.STRING.SEPTEMBER,
        BxfCalendarConstants.STRING.OCTOBER,
        BxfCalendarConstants.STRING.NOVEMBER,
        BxfCalendarConstants.STRING.DECEMBER,
    ];
    static DAYS = [
        BxfCalendarConstants.STRING.SUNDAY,
        BxfCalendarConstants.STRING.MONDAY,
        BxfCalendarConstants.STRING.TUESDAY,
        BxfCalendarConstants.STRING.WEDNESDAY,
        BxfCalendarConstants.STRING.THURSDAY,
        BxfCalendarConstants.STRING.FRIDAY,
        BxfCalendarConstants.STRING.SATURDAY,
    ];
    static FULL_DAYS = [
        BxfCalendarConstants.STRING.SUNDAY_FULL,
        BxfCalendarConstants.STRING.MONDAY_FULL,
        BxfCalendarConstants.STRING.TUESDAY_FULL,
        BxfCalendarConstants.STRING.WEDNESDAY_FULL,
        BxfCalendarConstants.STRING.THURSDAY_FULL,
        BxfCalendarConstants.STRING.FRIDAY_FULL,
        BxfCalendarConstants.STRING.SATURDAY_FULL,
    ];
    static WEEKEND = [
        BxfCalendarConstants.STRING.SATURDAY,
        BxfCalendarConstants.STRING.SUNDAY,
    ];
}

class BxfOverlayCalendarController extends BxfOverlayDropdownController {
    host;
    parentElement;
    targetElement;
    sourceElement;
    updateStateCallback;
    options;
    isOutsideOverlayCallback;
    constructor(host, parentElement, targetElement, sourceElement, updateStateCallback, options = {}, isOutsideOverlayCallback) {
        super(host, parentElement, targetElement, sourceElement, updateStateCallback, options, isOutsideOverlayCallback);
        this.host = host;
        this.parentElement = parentElement;
        this.targetElement = targetElement;
        this.sourceElement = sourceElement;
        this.updateStateCallback = updateStateCallback;
        this.options = options;
        this.isOutsideOverlayCallback = isOutsideOverlayCallback;
    }
    /**
     * Override focus trap context to stay within calendar container.
     */
    get focusTrapContext() {
        const { CONTAINER } = BxfCalendarConstants.STRING;
        return querySelectorDeep(`.${CONTAINER}`, this.sourceElement);
    }
    /**
     * Get item to focus when overlay opened.
     * Overrides listbox set in BxfOverlayDropdownController
     * @see BxfOverlayDropdownController
     */
    getItemToFocus() {
        return this.focusTrapContext;
    }
}

var BxfDatePickerSeparatorsEnum;
(function (BxfDatePickerSeparatorsEnum) {
    BxfDatePickerSeparatorsEnum["DASH"] = "-";
    BxfDatePickerSeparatorsEnum["PERIOD"] = ".";
    BxfDatePickerSeparatorsEnum["FORWARD_SLASH"] = "/";
    BxfDatePickerSeparatorsEnum["SPACE"] = " ";
    BxfDatePickerSeparatorsEnum["COMMA"] = ",";
})(BxfDatePickerSeparatorsEnum || (BxfDatePickerSeparatorsEnum = {}));

export { BxfCalendarConstants as B, BxfDatePickerDateFormatEnum as a, BxfDatePickerSeparatorsEnum as b, BxfOverlayCalendarController as c };
